import * as Immutable from 'immutable';
import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import './FlashMessages.scss';
import { FlashMessagesContent } from './FlashMessagesContent';
import { localStorageService } from '../../shared/services/localStorageService';

import { FlashMessageLinkHandlers } from './FlashMessages';

interface FlashMessagesProps {
  allMessages: any;
  location: string;
  handleRemove: (path: string[], id: string) => void;
  handleRemoveBlink: (path: string[], id: string) => void;
  showCloseButton: boolean;
  linkHandlers?: FlashMessageLinkHandlers;
}

type FlashMessagesPropsGeneric = FlashMessagesProps & InjectedIntlProps;

class Main extends React.Component<FlashMessagesPropsGeneric, {}> {
  private timerOutAddedFlashMessages: any;
  private timerOutAddedBlinkFlashMessages: any;

  constructor(props: FlashMessagesPropsGeneric) {
    super(props);
    this.timerOutAddedFlashMessages = [];
    this.timerOutAddedBlinkFlashMessages = [];
  }

  handlerClose = (id: string, context: string, msg: string) => () => {
    if (msg === 'message.consultant.vbc' || msg === 'message.user.vbc') {
      localStorageService?.setItem(msg, 'hide');
    }
    this.props.handleRemove([this.props.location, context], id);
  };

  setMessages() {
    const { allMessages, location } = this.props;

    let results: any[] = [];

    if (allMessages) {
      allMessages.forEach((messagesCtx: any) =>
        messagesCtx.forEach((message: any) => {
          const type = message.getIn(['options', 'type']);
          const links = message.getIn(['options', 'links']);
          const props = message.getIn(['options', 'props']);
          const context = message.getIn(['options', 'context']);
          const timerOut = message.getIn(['options', 'timerOut']);
          const inputType = message.getIn(['options', 'inputType']);
          const notBlink = message.getIn(['options', 'notBlink']);
          const parseHtml = message.getIn(['options', 'parseHtml']);
          const blink = message.getIn(['options', 'blink']);
          const id = message.get('id');
          const msg = message.getIn(['message', 0, 'msg']);
          const handlerCloseFlash = this.handlerClose(id, context, msg);
          const modifiers = this.setBlink(blink, notBlink, id, location, context);
          const messages = message.get('message');
          const needIntl = message.getIn(['options', 'intl']);
          const excludedLinks = message.getIn(['options', 'excludedLinks'])
            ? message.getIn(['options', 'excludedLinks'])
            : Immutable.List();

          this.handleTimeout(timerOut, id, location, context);

          results = results.concat({
            type,
            links,
            props,
            context,
            timerOut,
            inputType,
            modifiers,
            id,
            handlerCloseFlash,
            messages,
            needIntl,
            excludedLinks,
            parseHtml,
          });
        })
      );
    }

    return Immutable.fromJS(results);
  }

  handleTimeout(timerOut: null | number, id: string, location: string, context: string) {
    if (timerOut !== null && this.timerOutAddedFlashMessages.includes(id) === false) {
      this.timerOutAddedFlashMessages = this.timerOutAddedFlashMessages.concat(id);
      setTimeout(() => {
        this.props.handleRemove([location, context], id);
        this.timerOutAddedFlashMessages = this.timerOutAddedFlashMessages.filter((idMsg: string) => idMsg !== id);
      }, timerOut);
    }
  }

  setBlink(blink: boolean, notBlink: boolean, id: string, location: string, context: string) {
    const shouldBlink = blink && notBlink === false;

    if (shouldBlink) {
      this.timerOutAddedBlinkFlashMessages = this.timerOutAddedBlinkFlashMessages.concat(id);
      setTimeout(() => {
        this.props.handleRemoveBlink([location, context], id);
        this.timerOutAddedBlinkFlashMessages = this.timerOutAddedBlinkFlashMessages.filter((idMsg: string) => idMsg !== id);
      }, 500);
    }

    return shouldBlink ? ['blink'] : ['not-blink'];
  }

  render(): React.ReactNode {
    const messages = this.setMessages();

    // @ts-expect-error ImmutableJS .size on unknown return type
    return messages && messages.size > 0
      ? // @ts-expect-error ImmutableJS .map on unknown return type
        messages.map((message: any, index: number) => (
          <React.Fragment key={`flashMessagesContent--${index}`}>
            <FlashMessagesContent
              intl={this.props.intl}
              index={index}
              handlerCloseFlash={message.get('handlerCloseFlash')}
              modifiers={message.get('modifiers')}
              type={message.get('type')}
              messages={message.get('messages')}
              links={message.get('links')}
              needIntl={message.get('needIntl')}
              props={message.get('props')}
              inputType={message.get('inputType')}
              excludedLinks={message.get('excludedLinks')}
              showCloseButton={this.props.showCloseButton}
              parseHtml={message.get('parseHtml')}
              linkHandlers={this.props.linkHandlers}
            />
          </React.Fragment>
        ))
      : null;
  }
}

export default injectIntl(Main);
